"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const native_1 = require("@react-navigation/native");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../../app-reduxs/app/slice"));
const slice_2 = require("../../../app-reduxs/articleCreating/slice");
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const IC_REMOVE_HASHTAG_1 = __importDefault(require("../../../assets/icons/IC_REMOVE_HASHTAG"));
const components_1 = require("../../../components");
const LoadingLogin_1 = __importDefault(require("../../../components/loading/LoadingLogin"));
const ModalConfirmDeleteArticle_1 = __importDefault(require("../../../components/modal/ModalConfirmDeleteArticle"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const apis_1 = require("../../../networking/apis");
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const styles_1 = __importDefault(require("./styles"));
var pHiragana = "[\\u3041-\\u3096\\u309D-\\u309F]|\\uD82C\\uDC01|\\uD83C\\uDE00";
var pKatakana = "[\\u30A1-\\u30FA\\u30FD-\\u30FF\\u31F0-\\u31FF\\u32D0-\\u32FE\\u3300-\\u3357\\uFF66-\\uFF6F\\uFF71-\\uFF9D]|\\uD82C\\uDC00";
var pHan = "[\\u2E80-\\u2E99\\u2E9B-\\u2EF3\\u2F00-\\u2FD5\\u3005\\u3007\\u3021-\\u3029\\u3038-\\u303B\\u3400-\\u4DB5\\u4E00-\\u9FD5\\uF900-\\uFA6D\\uFA70-\\uFAD9]|[\\uD840-\\uD868\\uD86A-\\uD86C\\uD86F-\\uD872][\\uDC00-\\uDFFF]|\\uD869[\\uDC00-\\uDED6\\uDF00-\\uDFFF]|\\uD86D[\\uDC00-\\uDF34\\uDF40-\\uDFFF]|\\uD86E[\\uDC00-\\uDC1D\\uDC20-\\uDFFF]|\\uD873[\\uDC00-\\uDEA1]|\\uD87E[\\uDC00-\\uDE1D]";
var regex = new RegExp("^([\\wｰー]|" + pHiragana + "|" + pKatakana + "|" + pHan + ")+$");
const CreateArticleHashtag = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const navigation = (0, native_1.useNavigation)();
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const articleCreating = (0, react_redux_1.useSelector)((state) => state.articleCreatingReducer);
    const [confirmVisible, setConfirmVisible] = (0, react_1.useState)(false);
    const [hashtags, setHashtags] = (0, react_1.useState)(articleCreating.hashtags);
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const refTextInput = (0, react_1.createRef)();
    const refInputValue = (0, react_1.useRef)('');
    const isArticle = articleCreating.content_type == 1;
    (0, react_1.useEffect)(() => {
        if (!articleCreating.content_type) {
            navigation.reset({ index: 0, routes: [{ name: Routes_1.default.MAINTABBAR }] });
        }
    }, [articleCreating]);
    (0, react_1.useEffect)(() => {
        const handleBeforeUnload = (event) => {
            const message = 'Are you sure you want to leave?';
            event.returnValue = message;
            return message;
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);
    const removeHashtag = (index) => {
        const newHashtags = [...hashtags];
        newHashtags.splice(index, 1);
        setHashtags(newHashtags);
    };
    const addHashtag = () => {
        refInputValue.current = refInputValue.current.trim();
        if (!refInputValue.current)
            return;
        if (refInputValue.current.startsWith('#') || refInputValue.current.startsWith('＃')) {
            dispatch(slice_1.default.actions.setToastType(false));
            dispatch(slice_1.default.actions.showToast("#は自動で入力されます"));
            return;
        }
        if (!refInputValue.current.match(regex)) {
            dispatch(slice_1.default.actions.setToastType(false));
            dispatch(slice_1.default.actions.showToast("無効なハッシュタグです"));
            return;
        }
        const hashTagIdx = hashtags.findIndex(tag => tag === refInputValue.current);
        if (hashTagIdx !== -1) {
            dispatch(slice_1.default.actions.setToastType(false));
            dispatch(slice_1.default.actions.showToast("同じハッシュタグを入力できません"));
            return;
        }
        setHashtags([...hashtags, refInputValue.current]);
        refInputValue.current = '';
        refTextInput.current?.clear();
    };
    const navigateToConfirmStep = () => {
        refInputValue.current = '';
        refTextInput.current?.clear();
        dispatch((0, slice_2.addHashtagsAction)(hashtags));
        (0, rootNavigation_1.navigate)(Routes_1.default.CREATE_ARTICLE_CONFIRM);
    };
    const handlePostArticle = async (status) => {
        const form = new FormData();
        if (!!articleCreating.inherited_from_article_id) {
            form.append('inherited_from_article_id', `${articleCreating.inherited_from_article_id}`);
        }
        if (!!articleCreating.inherited_from_user_id) {
            form.append('inherited_from_user_id', `${articleCreating.inherited_from_user_id}`);
        }
        form.append('title', articleCreating.title);
        form.append('content_type', `${articleCreating.content_type}`);
        if (!!articleCreating.thumbnail_image) {
            const file = await (0, helpler_1.convertImageUrlToFile)(articleCreating.thumbnail_image);
            if (file) {
                form.append('thumbnail_image', file);
            }
        }
        form.append('price_type', '1');
        const contentResizeImage = (0, helpler_1.changeWidthHeightToPercentage)(articleCreating.full_text);
        form.append('full_text', contentResizeImage);
        // form.append('full_text', articleCreating.full_text)
        form.append('posting_datetime', (0, moment_1.default)().format('YYYY-MM-DD HH:mm:ss'));
        form.append('status', `${status}`);
        articleCreating.hashtags.map((item, index) => {
            form.append(`hash_tag_name[${index}]`, item);
        });
        setLoading(true);
        apis_1.ArticleApi.postArticle(form)
            .then((response) => {
            const message = status == 0 ?
                "下書きに保存しました"
                :
                    articleCreating.content_type == 1 ?
                        "記事を公開しました"
                        :
                            "自分史を公開しました";
            dispatch(slice_1.default.actions.showToast(message));
            (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                screen: Routes_1.default.DETAIL_STORY,
                params: {
                    id: response.data.article_id
                }
            });
            dispatch((0, slice_2.destroyArticleAction)());
        })
            .catch(err => {
            console.log(err);
        })
            .finally(() => {
            setLoading(false);
        });
    };
    const handleEditArticle = async (status) => {
        const form = new FormData();
        form.append('title', articleCreating.title);
        form.append('content_type', `${articleCreating.content_type}`);
        if (!!articleCreating.thumbnail_image) {
            const file = await (0, helpler_1.convertImageUrlToFile)(articleCreating.thumbnail_image);
            if (file) {
                form.append('thumbnail_image', file);
            }
        }
        if (!!articleCreating.inherited_from_user_id && articleCreating.inherited_from_user_id != articleCreating.inherited_from_user_id_root) {
            form.append('inherited_from_user_id', `${articleCreating.inherited_from_user_id}`);
        }
        form.append('price_type', '1');
        const contentResizeImage = (0, helpler_1.changeWidthHeightToPercentage)(articleCreating.full_text);
        form.append('full_text', contentResizeImage);
        // form.append('full_text', articleCreating.full_text)
        form.append('status', `${status}`);
        articleCreating.hashtags.map((item, index) => {
            form.append(`hash_tag_name[${index}]`, item);
        });
        setLoading(true);
        apis_1.ArticleApi.editArticle(articleCreating.article_id, form)
            .then(() => {
            const message = status == 0 ?
                "編集しました"
                :
                    articleCreating.content_type == 1 ?
                        "記事を公開しました"
                        :
                            "自分史を公開しました";
            dispatch(slice_1.default.actions.showToast(message));
            navigation.dispatch(native_1.StackActions.popToTop());
            (0, rootNavigation_1.navigate)(Routes_1.default.DETAIL_STORY, { id: articleCreating.article_id });
            dispatch((0, slice_2.destroyArticleAction)());
        })
            .catch(err => {
            console.log(err);
        })
            .finally(() => {
            setLoading(false);
        });
    };
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.Pressable, { style: styles_1.default.container, onPress: react_native_1.Keyboard.dismiss, disabled: helpler_1.isWeb },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, title: isArticle ? '記事作成' : '自分史作成', styleContainer: {
                backgroundColor: Colors_1.default.white,
            }, leftIcon: react_1.default.createElement(CustomText_1.default, { style: styles_1.default.headerText }, "\u30AD\u30E3\u30F3\u30BB\u30EB"), onLeftPress: () => setConfirmVisible(true) }),
        react_1.default.createElement(react_native_1.ScrollView, { style: { flex: 1 }, contentContainerStyle: {
                paddingHorizontal: (0, scale_1.scale)(16),
                paddingVertical: (0, scale_1.scale)(24),
            }, showsVerticalScrollIndicator: false },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.row },
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.decor }),
                react_1.default.createElement(CustomText_1.default, { style: styles_1.default.title }, "\u30CF\u30C3\u30B7\u30E5\u30BF\u30B0\u8A2D\u5B9A")),
            react_1.default.createElement(CustomText_1.default, { style: styles_1.default.description },
                isArticle ? '記事' : '自分史',
                "\u306B\u767B\u9332\u3059\u308B\u30CF\u30C3\u30B7\u30E5\u30BF\u30B0\u3092\u8A2D\u5B9A\u3057\u3066\u4E0B\u3055\u3044\u3002"),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.hashtagList },
                hashtags.map((item, index) => {
                    return (react_1.default.createElement(react_native_1.View, { key: index, style: styles_1.default.hashtagItem },
                        react_1.default.createElement(CustomText_1.default, { numberOfLines: 1, style: styles_1.default.hashtagText }, item),
                        react_1.default.createElement(react_native_1.Pressable, { onPress: () => removeHashtag(index) },
                            react_1.default.createElement(IC_REMOVE_HASHTAG_1.default, null))));
                }),
                hashtags.length < 30 && (react_1.default.createElement(react_native_1.TextInput, { ref: refTextInput, placeholder: "\u30CF\u30C3\u30B7\u30E5\u30BF\u30B0\u3092\u5165\u529B", placeholderTextColor: '#C8C8C8', style: styles_1.default.textInput, onChangeText: (text) => (refInputValue.current = text.trim()) }))),
            react_1.default.createElement(components_1.BorderButton, { title: "\u30BF\u30B0\u3092\u8FFD\u52A0", style: styles_1.default.addHashtagBtn, textStyle: styles_1.default.addHashtagLabel, onPress: addHashtag }),
            react_1.default.createElement(components_1.LinearButton, { title: "\u516C\u958B\u306B\u9032\u3080", style: styles_1.default.nextBtn, textStyle: styles_1.default.nextBtnLabel, containerStyle: {
                    marginTop: (0, scale_1.scale)(32),
                }, onPress: navigateToConfirmStep })),
        react_1.default.createElement(ModalConfirmDeleteArticle_1.default, { visible: confirmVisible, onClose: () => setConfirmVisible(false), title: articleCreating.content_type == 2
                ? '自分史の作成を取り消しますか？'
                : '記事の作成を取り消しますか？', content: "\u5165\u529B\u3057\u305F\u5185\u5BB9\u306F\u4FDD\u5B58\u3055\u308C\u307E\u305B\u3093\u3002", confirmLabel: (!articleCreating.article_id || articleCreating.status == 0) ? "下書きに保存する" : undefined, cancelLabel: "\u30AD\u30E3\u30F3\u30BB\u30EB", onConfirm: () => { setConfirmVisible(false), articleCreating.article_id ? handleEditArticle(0) : handlePostArticle(0); }, onConfirm1: () => {
                (0, rootNavigation_1.goBack)();
                (0, rootNavigation_1.goBack)();
                setConfirmVisible(false);
                dispatch((0, slice_2.destroyArticleAction)());
            }, confirmLabel1: "\u7834\u68C4\u3059\u308B" }),
        isLoading && react_1.default.createElement(LoadingLogin_1.default, null)));
};
exports.default = CreateArticleHashtag;
